export const APP_NAME = 'Houston Airports - Official';
export const APP_ID_IOS = '1613307854';
export const ANDROID_PACKAGE = 'org.houston.airports';
export const BANNER_KEY = 'app-banner-dismissed';
export const APPLE_STORE_URL =
	'https://apps.apple.com/us/app/houston-airports-official';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details';
